const shuffleRow = (row) => {
  const l = row.length;
  for (let i = 0; i < l; i += 1) {
    const r1 = Math.floor(Math.random() * l);
    const r2 = Math.floor(Math.random() * l);
    const prev = row[r1];
    row[r1] = row[r2];
    row[r2] = prev;
  }
}
const shuffleGrid = (grid) => {
  for (let i = 0; i < grid.length; i += 1) {
    shuffleRow(grid[i]);
  }
}
export default shuffleGrid;



// WEBPACK FOOTER //
// ./src/shuffleGrid.js